import React, { useState } from 'react';
import { truncate } from 'lodash'; 
import { Helmet } from 'react-helmet';
import { useHistory, useParams } from 'react-router-dom';

import CardLayout from '@magoosh/layouts/card';
import { Select } from '@magoosh/lib/forms';
import useSearchQuery from '@magoosh/utils/use_search_query';
import { paths } from 'config/path_helpers';

import ContextualLink from '@test_prep/app/components/contextual_link';
import { useQueries } from '@test_prep/app/queries';

import ScoreReportPart from '../components/score_report_part';

export default (props) => {
  const history = useHistory();
  const { id, answerId } = useParams();
  const q = useQueries();
  const [volume, setVolume] = useState(1);

  const pagePath = paths.scoreReportAnswer(id, answerId);
  const pageQuery = q.pageQuery(pagePath, { keepPreviousData: true });
  const page = pageQuery.data;

  const currentAnswer = (page?.answers || []).find((answer) => answer.id === parseInt(answerId));
  const scoreReportPart = (page?.scoreReport?.content?.parts || []).find(
    (part) => part.answerId === currentAnswer?.id
  );

  const navigateToAnswer = (newAnswerId) => {
    const path = paths.scoreReportAnswer(id, newAnswerId);
    history.replace(path + window.location.search);
  };

  return (
    <>
      <Helmet>
        <title>
          {
            page?.scoreReport?.reportType ? (
              `${page.scoreReport.reportType} Score Report - Response Details`
            ) : 'Score Report - Response Details'
          }
        </title>
      </Helmet>

      <CardLayout
        linkComponent={ContextualLink}
        loading={!page}
        subnav={{
          title: 'Response Details',
          backLink: {
            path: (useSearchQuery()['back_path'] as string) || paths.scoreReport(id),
            name: (useSearchQuery()['back_name'] as string) || 'Full Score Report'
          }
        }}
      >
        {({ loading }) => {
          if (loading) return;

          return (
            <div className="d-flex flex-column gap-m">
              <CardLayout.Card className="d-flex flex-column gap-m">
                <div className="d-flex flex-column gap-xxs">
                  <h3 className="u-margin-A-n">
                    <strong>Choose a response</strong>
                  </h3>

                  <div>
                    This response is part of a larger set.
                    {' '}
                    <ContextualLink className="text-body" href={paths.scoreReport(id)}>
                      See all responses
                    </ContextualLink>
                  </div>
                </div>

                <div className="d-flex">
                  <Select
                    onChange={(e) => {
                      if (!e.target.value) return;
                      navigateToAnswer(e.target.value);
                    }}
                    value={currentAnswer.id}
                  >
                    {
                      page.answers.map((answer, idx) => (
                        <option key={answer.id} value={answer.id}>
                          Response #{idx + 1}: {truncate(answer.prompt.content.audio.transcript, { length: 60 })}
                        </option>
                      ))
                    }
                  </Select>
                </div>
              </CardLayout.Card>

              <CardLayout.Card className="d-flex flex-column gap-m">
                <h3 className="u-margin-A-n">
                  <strong>Your performance</strong>
                </h3>

                <div className="u-border-A-s u-padding-A-s" style={{ borderRadius: 8 }}>
                  <ScoreReportPart
                    analysisDefaultExpanded
                    answer={currentAnswer}
                    reportType={page.scoreReport.reportType}
                    scoreReportPart={scoreReportPart}
                    volume={volume}
                    setVolume={setVolume}
                  />
                </div>
              </CardLayout.Card>
            </div>
          );
        }}
      </CardLayout>
    </>
  );
};
